// Navigation, Footer-Bewertungsaufruf und Homepage-Teaser für die Firmen-/Privatkunden-Seiten (Schlüssel nav_*, seo_n_*, rv_*, promo_*).
const de = {
  nav_my_profile: "Mein Profil",
  nav_group_partner: "Partner",
  seo_n_partner: "Partner – Überblick",
  seo_n_partner_orders: "Aufträge & Disposition",
  seo_n_partner_app: "Fahrer-App",
  seo_n_partner_payout: "Abrechnung & Auszahlung",
  nav_business: "Firmenkunden",
  nav_private: "Privatkunden",
  nav_group_business: "Firmen",
  nav_group_private: "Privat",
  seo_n_business: "Firmenkonto – Überblick",
  seo_n_business_staff: "Mitarbeiter & Rollen verwalten",
  seo_n_business_limits: "Limits & Freigaben",
  seo_n_business_invoice: "Rechnung & Abrechnung",
  seo_n_register_company: "Firmenkonto beantragen",
  seo_n_private: "Privatkunden – Überblick",
  seo_n_private_account: "Kundenkonto im Detail",
  seo_n_private_points: "Punkte & Treuestufen",
  rv_title: "Ihre Meinung zählt – wir schätzen jede einzelne",
  rv_text: "Waren Sie zufrieden oder gibt es etwas zu verbessern? Wir freuen uns über Ihre ehrliche, neutrale Bewertung – jede Meinung hilft uns, besser zu werden.",
  rv_trustpilot: "Auf Trustpilot bewerten",
  rv_tripadvisor: "Auf Tripadvisor bewerten",
  promo_eyebrow: "Kundenkonto & Firmen",
  promo_title: "Mehr Vorteile mit Ihrem",
  promo_title_accent: "GoTransfer24-Konto.",
  promo_account_title: "Kostenloses Kundenkonto",
  promo_account_text: "Buchungen ohne Code verwalten, Adressen speichern und mit Passkey sicher anmelden.",
  promo_points_title: "Punkte & bis zu 7 % Rabatt",
  promo_points_text: "Pro Euro ein Punkt – mit den Reise-Leveln Explorer, Voyager und Globetrotter sparen Sie automatisch bei jeder Fahrt.",
  promo_company_title: "Firmenkonto mit Rechnung",
  promo_company_text: "Fester Firmenrabatt, Mitarbeiter mit Limits, Freigaben und PDF-Rechnung mit allen Fahrten.",
  promo_more: "Mehr erfahren",
  promo_register: "Konto erstellen",
};
const en = {
  nav_my_profile: "My profile",
  nav_group_partner: "Partners",
  seo_n_partner: "Partners – overview",
  seo_n_partner_orders: "Jobs & dispatch",
  seo_n_partner_app: "Driver app",
  seo_n_partner_payout: "Settlement & payout",
  nav_business: "Business",
  nav_private: "Private",
  nav_group_business: "Business",
  nav_group_private: "Private",
  seo_n_business: "Company account – overview",
  seo_n_business_staff: "Manage employees & roles",
  seo_n_business_limits: "Limits & approvals",
  seo_n_business_invoice: "Invoice & billing",
  seo_n_register_company: "Apply for a company account",
  seo_n_private: "Private customers – overview",
  seo_n_private_account: "Customer account in detail",
  seo_n_private_points: "Points & loyalty tiers",
  rv_title: "Your opinion matters – we value every single one",
  rv_text: "Were you happy, or is there something to improve? We appreciate your honest, neutral review – every opinion helps us get better.",
  rv_trustpilot: "Review on Trustpilot",
  rv_tripadvisor: "Review on Tripadvisor",
  promo_eyebrow: "Account & business",
  promo_title: "More benefits with your",
  promo_title_accent: "GoTransfer24 account.",
  promo_account_title: "Free customer account",
  promo_account_text: "Manage bookings without a code, save addresses and sign in securely with a passkey.",
  promo_points_title: "Points & up to 7 % discount",
  promo_points_text: "One point per euro – with the travel levels Explorer, Voyager and Globetrotter you save automatically on every ride.",
  promo_company_title: "Company account with invoice",
  promo_company_text: "Fixed company discount, employees with limits, approvals and a PDF invoice with all rides.",
  promo_more: "Learn more",
  promo_register: "Create account",
};
const tr = {
  nav_my_profile: "Profilim",
  nav_group_partner: "Ortaklar",
  seo_n_partner: "Ortaklar – genel bakış",
  seo_n_partner_orders: "İşler ve operasyon",
  seo_n_partner_app: "Sürücü uygulaması",
  seo_n_partner_payout: "Hesaplaşma ve ödeme",
  nav_business: "Kurumsal",
  nav_private: "Bireysel",
  nav_group_business: "Kurumsal",
  nav_group_private: "Bireysel",
  seo_n_business: "Şirket hesabı – genel bakış",
  seo_n_business_staff: "Çalışan ve rol yönetimi",
  seo_n_business_limits: "Limitler ve onaylar",
  seo_n_business_invoice: "Fatura ve ödeme",
  seo_n_register_company: "Şirket hesabı başvurusu",
  seo_n_private: "Bireysel müşteriler – genel bakış",
  seo_n_private_account: "Müşteri hesabı ayrıntıları",
  seo_n_private_points: "Puanlar ve sadakat seviyeleri",
  rv_title: "Görüşünüz önemli – her birine değer veriyoruz",
  rv_text: "Memnun kaldınız mı, yoksa geliştirmemiz gereken bir şey var mı? Dürüst ve tarafsız değerlendirmenize memnun oluruz – her görüş gelişmemize yardımcı olur.",
  rv_trustpilot: "Trustpilot'ta değerlendir",
  rv_tripadvisor: "Tripadvisor'da değerlendir",
  promo_eyebrow: "Hesap ve şirketler",
  promo_title: "Daha fazla avantaj:",
  promo_title_accent: "GoTransfer24 hesabınız.",
  promo_account_title: "Ücretsiz müşteri hesabı",
  promo_account_text: "Rezervasyonları kodsuz yönetin, adresleri kaydedin ve passkey ile güvenle giriş yapın.",
  promo_points_title: "Puanlar ve %7'ye varan indirim",
  promo_points_text: "Euro başına bir puan – Bronz, Gümüş ve Altın ile her yolculukta otomatik tasarruf edin.",
  promo_company_title: "Faturalı şirket hesabı",
  promo_company_text: "Sabit şirket indirimi, limitli çalışanlar, onaylar ve tüm yolculukları içeren PDF fatura.",
  promo_more: "Daha fazla",
  promo_register: "Hesap oluştur",
};
const pl = {
  nav_my_profile: "Mój profil",
  nav_group_partner: "Partnerzy",
  seo_n_partner: "Partnerzy – przegląd",
  seo_n_partner_orders: "Zlecenia i dyspozycja",
  seo_n_partner_app: "Aplikacja kierowcy",
  seo_n_partner_payout: "Rozliczenie i wypłata",
  nav_business: "Dla firm",
  nav_private: "Dla osób prywatnych",
  nav_group_business: "Firmy",
  nav_group_private: "Prywatnie",
  seo_n_business: "Konto firmowe – przegląd",
  seo_n_business_staff: "Pracownicy i role",
  seo_n_business_limits: "Limity i zatwierdzenia",
  seo_n_business_invoice: "Faktura i rozliczenie",
  seo_n_register_company: "Złóż wniosek o konto firmowe",
  seo_n_private: "Klienci prywatni – przegląd",
  seo_n_private_account: "Konto klienta w szczegółach",
  seo_n_private_points: "Punkty i poziomy lojalności",
  rv_title: "Twoja opinia się liczy – cenimy każdą",
  rv_text: "Czy byłeś(-aś) zadowolony(-a), czy coś poprawić? Chętnie przeczytamy Twoją szczerą, neutralną opinię – każda pomaga nam być lepszymi.",
  rv_trustpilot: "Oceń na Trustpilot",
  rv_tripadvisor: "Oceń na Tripadvisor",
  promo_eyebrow: "Konto i firmy",
  promo_title: "Więcej korzyści z",
  promo_title_accent: "kontem GoTransfer24.",
  promo_account_title: "Bezpłatne konto klienta",
  promo_account_text: "Zarządzaj rezerwacjami bez kodu, zapisuj adresy i loguj się bezpiecznie kluczem dostępu.",
  promo_points_title: "Punkty i do 7 % rabatu",
  promo_points_text: "Jeden punkt za euro – z poziomami Brąz, Srebro i Złoto oszczędzasz automatycznie.",
  promo_company_title: "Konto firmowe z fakturą",
  promo_company_text: "Stały rabat firmowy, pracownicy z limitami, zatwierdzenia i faktura PDF ze wszystkimi przejazdami.",
  promo_more: "Dowiedz się więcej",
  promo_register: "Załóż konto",
};
const uk = {
  nav_my_profile: "Мій профіль",
  nav_group_partner: "Партнери",
  seo_n_partner: "Партнери – огляд",
  seo_n_partner_orders: "Замовлення та диспетчеризація",
  seo_n_partner_app: "Застосунок водія",
  seo_n_partner_payout: "Розрахунки та виплати",
  nav_business: "Для компаній",
  nav_private: "Для приватних клієнтів",
  nav_group_business: "Компанії",
  nav_group_private: "Приватно",
  seo_n_business: "Акаунт компанії – огляд",
  seo_n_business_staff: "Співробітники та ролі",
  seo_n_business_limits: "Ліміти та погодження",
  seo_n_business_invoice: "Рахунок та розрахунки",
  seo_n_register_company: "Подати заявку на акаунт компанії",
  seo_n_private: "Приватні клієнти – огляд",
  seo_n_private_account: "Акаунт клієнта детально",
  seo_n_private_points: "Бали та рівні лояльності",
  rv_title: "Ваша думка важлива – ми цінуємо кожну",
  rv_text: "Ви залишилися задоволені чи є що покращити? Будемо вдячні за чесний, нейтральний відгук – кожна думка допомагає нам ставати кращими.",
  rv_trustpilot: "Залишити відгук на Trustpilot",
  rv_tripadvisor: "Залишити відгук на Tripadvisor",
  promo_eyebrow: "Акаунт і компанії",
  promo_title: "Більше переваг із",
  promo_title_accent: "акаунтом GoTransfer24.",
  promo_account_title: "Безкоштовний акаунт клієнта",
  promo_account_text: "Керуйте бронюваннями без коду, зберігайте адреси та входьте безпечно з passkey.",
  promo_points_title: "Бали та знижка до 7 %",
  promo_points_text: "Один бал за євро – з рівнями Бронза, Срібло та Золото ви заощаджуєте автоматично.",
  promo_company_title: "Акаунт компанії з рахунком",
  promo_company_text: "Фіксована знижка, співробітники з лімітами, погодження та PDF-рахунок з усіма поїздками.",
  promo_more: "Дізнатися більше",
  promo_register: "Створити акаунт",
};
export default { de, en, tr, pl, uk };
